<template>
  <v-row>
    <div class="col-md-12 home-box">
      <Breadcrumbs :title="'Due Customer Report'" />
      <DueCustomerReport />
    </div>
    <div class="col-md-12 home-tabs-body"></div>
  </v-row>
</template>

<script>
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
import DueCustomerReport from "@/components/reports/DueCustomerReport.vue";
export default {
  components: { Breadcrumbs, DueCustomerReport },
};
</script>